import React from 'react';
import classnames from 'classnames';

const ModalCardTitle = ({ children, className, ...props }) => {
  return (
    <p {...props} className={classnames('modal-card-title', className)}>
      {children}
    </p>
  );
};

export default ModalCardTitle;
